<template>
  <div class="find-goods" :class="{'goods-next': next}" @click.stop.prevent="goPage">
    <div class="goods-title">
      <h4 v-if="configInfo" :style="{'color': configInfo.titleColor}">{{configInfo.title || '发现好货'}}</h4>
      <template v-if="findGoodsInfo.type=='product'">
        <div class="goods-part" v-if="!next">
          <span>{{findGoodsInfo.timeStr && findGoodsInfo.timeStr.split(':')[0]}}点场</span>{{countTime}}
        </div>
        <div class="goods-part" v-else-if="findGoodsInfo.timeStr"><span>{{findGoodsInfo.timeStr}}</span>活动预告</div>
      </template>
    </div>
    <div v-if="configInfo" class="goods-desc" :style="{'color': configInfo.sdColor}">{{configInfo.description || '精心挑选每日上新'}}</div>
    <div class="goods-product" v-if="findGoodsInfo.products">
      <div v-for="item in findGoodsInfo.products" :key="item.id">
        <div class="goods-pro-img">
          <vanImg :src="(item.customImageUrl || item.imageUrl) | imageToHttps | imageToWebp($webpSurpport)" alt="" />
        </div>
        <p>￥<span class="price-num">{{item.lowestPrice || item.flashsalePrice}}</span><span v-if="item.lowestPrice" class="lowest-tip">起</span></p>
        <del>￥<span class="price-num">{{item.lowestCrossedPrice || item.miniPrice}}</span><span v-if="item.lowestCrossedPrice" class="lowest-tip">起</span></del>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '../api'

export default {
  name: 'findGoods',
  props: {
    refresh: Number,
    activityId: [Number, String],
    configInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      findGoodsInfo: {}, // 发现好货

      next: false, // 是否是预告
      hour: '',
      min: '',
      sec: '',
      timer: null, // 定时器
      remain: 0, // 剩余时间
    }
  },
  computed: {
    ...mapGetters(['accessToken']),
    ...mapGetters({
      location: 'getlocationInfo',
    }),
    countTime() {
      return this.hour + ':' + this.min + ':' + this.sec;
    }
  },
  watch: {
    refresh(newValue, oldVal) {
      if (newValue !== oldVal) {
        this.flashSale()
      }
    }
  },
  mounted() {
    this.flashSale()
  },
  methods: {
    // 发现好物
    flashSale() {
      Api.getFlashSaleNew({
        bannerId: 1,
        activityId: this.activityId,
        provinceId: this.location.provinceId,
        cityId: this.location.cityId,
        streetId: this.location.townshipId,
        districtId: this.location.districtId,
        streetCode: this.location.townshipCode,
      }, {
        appId: 'MB-UZHSH-0000',
        accountToken: this.accessToken,
        timestamp: new Date().getTime(),
        clientId: this.$util.getGuId(),
        sequenceId: this.$util.randomString()
      }).then(res => {
        let result = res.data
        if (result.data) {
          if (result.data.activity && result.data.activity.products && result.data.activity.products.length) {
            this.findGoodsInfo = {
              ...result.data.activity,
              type: 'product',
              products: result.data.activity.products.splice(0, 3)
            }
          } else if (result.data.storeFlashSaleProductList && result.data.storeFlashSaleProductList.length) {
            this.findGoodsInfo = {
              type: 'store',
              products: result.data.storeFlashSaleProductList.splice(0, 3)
            }
          } else {
            this.findGoodsInfo = {}
          }
        }

        this.remain = result?.data?.countdown
        if (this.remain > 0) {
          this.countdown()
          this.next = false
        } else {
          this.next = true
        }
      }).catch(err => console.log(err))
    },
    /**
     * 发现好货倒计时结束
    */
    timeEnd() {
      console.log('time end')
      this.flashSale()
    },
    countdown() {
      clearInterval(this.timer)
      this.timer = setInterval(this.computeHourMinSec, 1000);
      this.computeHourMinSec()
    },
    computeHourMinSec() {
      let count = this.remain;
      if (count <= 0) {
        clearInterval(this.timer);
        // this.$emit('end')
        this.timeEnd()
        return;
      }
      count--;
      this.remain = count
      let h = Math.floor(count / 3600);
      let m = Math.floor((count % 3600) / 60);
      let s = count % 60;
      this.hour = this.toDoubleNumber(h);
      this.min = this.toDoubleNumber(m);
      this.sec = this.toDoubleNumber(s);
    },
    toDoubleNumber(num) {
      return num < 10 ? '0' + num : '' + num;
    },
    goPage() {
      // 埋点
      this.$util.gioTrackWithVariable('MB15598', {
        text: '发现好货'
      })
      if (this.findGoodsInfo.type === 'product') {
        this.$router.push(`/flashSale`) // 都跳 flashSale 
      } else if (this.findGoodsInfo.type === 'store') {
        this.$router.push(`/flashSale`) // 都跳 flashSale  
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.find-goods{
  width: 3.1rem;
  /* padding: .24rem 0 .2rem; */
}
.goods-title{
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: .5rem;
  h4{
    margin-right: 2px;
    font-size: .3rem;
    line-height: .44rem;
    font-weight: 600;
    color: #333;
  }
}
.goods-part{
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* width: 1.84rem; */
  height: .36rem;
  padding-right: .06rem;
  border-radius: .18rem;
  font-size: .2rem;
  color: #FF4545;
  overflow: hidden;
  border: 1px solid #FF4545;
  box-sizing: border-box;
  span{
    margin-left: -1px;
    margin-right: .06rem;
    padding: 0 .08rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: .36rem;
    border-radius: .18rem;
    font-size: .22rem;
    color: #fff;
    background: #FF4545;
  }
}

.goods-next{
  .goods-part{
    border: 1px solid #FF830D;
    color: #FF830D;
    span{
      background: #FF830D;
    }
  }
  .goods-desc{
    color: #FF830D;
  }
}

.goods-desc{
  font-size: .24rem;
  line-height: .36rem;
  color: #FF4545;
}

.goods-product{
  margin-top: .12rem;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  .lowest-tip{
    margin-left: .04rem;
  }
  .price-num{
    margin-left: -0.04rem;
  }
  > div{
    display: flex;
    flex-direction: column;
    width: 1.08rem;
    text-align: center;
    p{
      font-size: .24rem;
      line-height: .28rem;
      color: #FF4545;
      font-weight: 600;
      @include text-overflow(1);
    }
    del{
      font-size: .2rem;
      color: #999;
      line-height: .28rem;
      @include text-overflow(1);
    }
  }
}

.goods-pro-img{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.08rem;
  height: 1.08rem;
  padding: 2px;
  box-sizing: border-box;
  img{
    max-width: 100%;
    max-height: 100%;
  }
}

</style>
